import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';
import i18next from 'i18next';

const gqlGetValues = gql`
  query getSubregions($where: String, $offset: Int, $limit: Int, $order: String) {
    getSubregions(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: id
        description: name
      }
      recordCount
    }
  }
`;

export function useGetSubregionAsOptionsQuery() {
  return useLazyQuery(gqlGetValues, {
    fetchPolicy: 'cache-first',
  });
}

function useGetSubregionLazyQuery() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

// interface LcFsProps extends FsProps {
//   size?: 'sm' | 'lg';
// }

export const FieldSelectSubregion = ({
  label = i18next.t('Περιφερειακή Ενότητα'),
  name = 'subregionId',
  defaultValues = {},
  // size = 'sm',
  ...rest
}: FsProps) => {
  //const where = JSON.stringify({ isActive: true });
  return (
    <FieldSelectDB
      // height={size === 'lg' ? 32 : '22'}
      {...rest}
      label={label}
      name={name}
      sbLabel={(defaultValues as any)?.subregion?.name ?? undefined}
      //where={where}
      hook={useGetSubregionLazyQuery}
    />
  );
};
